(function () {
  if (!window.fetch || !window.DOMParser || !window.MutationObserver) return;
  var script = document.currentScript;
  var enRoot = ((script && script.getAttribute('data-trm-en-root')) || '').replace(/\/$/, '');
  var koRoot = /^\/ko(?=\/|$)/;

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function titleOf(a) {
    var t = a.getAttribute('data-product-title');
    if (!t) { var s = a.querySelector('.text'); t = s ? s.textContent : a.textContent; }
    return (t || '').replace(/\s+/g, ' ').trim();
  }
  function sectionUrl(sectionId, page) {
    var path = location.pathname.replace(koRoot, '') || '/';
    var params = new URLSearchParams(location.search);
    params.set('section_id', sectionId);
    if (page > 1) params.set('page', String(page)); else params.delete('page');
    return enRoot + path + '?' + params.toString();
  }
  function fetchPage(sectionId, page) {
    return fetch(sectionUrl(sectionId, page), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var found = {};
        if (!html) return found;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('a.card-title').forEach(function (a) {
          var h = handleOf(a);
          if (h && !found[h]) found[h] = titleOf(a);
        });
        return found;
      })
      .catch(function () { return {}; });
  }
  // section rendering API 係逐頁嘅：collections/all 第 1 頁 31 個 handle、第 2 頁 33 個，零重疊。
  // 之前淨係攞第 1 頁又 cache 咗，所以 scroll load 出嚟嗰批查唔到英文名，
  // decorate() 一標咗 data-trm-en 就唔會再試 —— 客見到第一行有副題、之後冇。
  // 而家撞到查唔到就逐頁揭落去，一頁一個 request（唔係一張卡一個）。
  var sections = {};
  var MAX_PAGES = 30;
  function state(id) {
    if (!sections[id]) sections[id] = { map: {}, next: 1, chain: Promise.resolve() };
    return sections[id];
  }
  function resolve(sectionId, handles) {
    var st = state(sectionId);
    st.chain = st.chain.then(function step() {
      var missing = handles.filter(function (h) { return !(h in st.map); });
      if (!missing.length || st.next > MAX_PAGES || st.done) return;
      var page = st.next++;
      return fetchPage(sectionId, page).then(function (found) {
        var keys = Object.keys(found);
        if (!keys.length) { st.done = true; return; }
        keys.forEach(function (h) { if (!(h in st.map)) st.map[h] = found[h]; });
        return step();
      });
    });
    return st.chain.then(function () { return st.map; });
  }

  var products = {};
  function englishProductTitle(handle) {
    if (!products[handle]) {
      products[handle] = fetch(enRoot + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) { return json && json.title ? String(json.title).replace(/\s+/g, ' ').trim() : ''; })
        .catch(function () { return ''; });
    }
    return products[handle];
  }
  // 查到（就算英文同韓文一樣，冇嘢要加）先標死。查唔到唔標，留返俾下一轉再試 ——
  // 一標死就等於將一次失敗變成永久失敗，呢個就係 2026-09-15 個 bug 嘅另一半。
  // 但要封頂，唔係每次 DOM 郁都無限重試：試夠 3 次就收手。
  var TRIES = 3;
  function decorate(a, en) {
    if (a.getAttribute('data-trm-en')) return;
    if (en == null || en === '') {
      var n = (+a.getAttribute('data-trm-en-try') || 0) + 1;
      if (n >= TRIES) a.setAttribute('data-trm-en', '1');
      else a.setAttribute('data-trm-en-try', String(n));
      return;
    }
    a.setAttribute('data-trm-en', '1');
    if (en === titleOf(a)) return;
    var span = document.createElement('span');
    span.className = 'trm-card-en';
    span.textContent = en;
    a.insertAdjacentElement('afterend', span);
  }
  function run(root) {
    var groups = {};
    (root || document).querySelectorAll('a.card-title:not([data-trm-en])').forEach(function (a) {
      var section = a.closest('.shopify-section');
      if (!section || !handleOf(a)) return;
      var id = section.id.replace(/^shopify-section-/, '');
      (groups[id] = groups[id] || []).push(a);
    });
    Object.keys(groups).forEach(function (id) {
      var handles = groups[id].map(handleOf);
      resolve(id, handles).then(function (map) {
        groups[id].forEach(function (a) {
          var h = handleOf(a);
          // 揭完都仲搵唔到（例如韓文 collection 有但英文冇），先至逐件貨問
          if (h in map) decorate(a, map[h]);
          else englishProductTitle(h).then(function (en) { decorate(a, en); });
        });
      });
    });
    (root || document).querySelectorAll('.trm-brand-stock__name:not([data-trm-en])').forEach(function (el) {
      var h = handleOf(el.closest('a') || el);
      if (!h) return;
      englishProductTitle(h).then(function (en) { decorate(el, en); });
    });
    (root || document).querySelectorAll('a.previewCartItem-name:not([data-trm-en]), .cart-item-name > a:not([data-trm-en])').forEach(function (a) {
      var h = handleOf(a);
      if (!h) return;
      englishProductTitle(h).then(function (en) { decorate(a, en); });
    });
  }

  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(document); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
})();
